module.exports = __webpack_public_path__ + "img/9788936456344.7b326f4b.jpg";